<template>
    <div
        :id="`warning-${typeLabel}`"
        v-if="isHasAdditionalContact && isValueEmpty"
    >
        <div class="alert alert-block alert-warning mt-2 mb-1 padding-alert">
            <small id="dialog-alert-message">
                Next available {{ typeLabel }} contact will be applied and
                assigned as primary when saved
            </small>
        </div>
    </div>
</template>

<script>
import { isEmpty, lowerCase } from "lodash";
import CLIENT from "@/constants/clients";

export default {
    props: {
        type: {
            type: Number,
            required: true
        },
        value: {
            type: [String, Number],
            required: true
        },
        contacts: {
            type: Array,
            required: true
        }
    },
    computed: {
        isHasAdditionalContact() {
            return this.contacts.some(
                contact => contact.type == this.type && !contact.is_primary
            );
        },
        isValueEmpty() {
            return isEmpty(this.value);
        },
        typeLabel() {
            return lowerCase(CLIENT.CONTACT_DETAIL_TYPE_LIST[this.type].LABEL);
        }
    }
};
</script>

<style scoped>
.padding-alert {
    padding: 10px;
}
</style>
